// import { Stack } from "@mui/system";
import "../style.css";
import StepOneIcon from "src/components/logos/StepOneIcon.png";
import { Typography, Stack, Button, Divider, IconButton, alpha } from "@mui/material";
import Check from "src/components/logos/Check.png";
import StepItem from "./StepItem";
import StepEmailContent from "./StepEmailContent";

export const TimelineStepFour = (props) => {
  const {
    onNext,
    onBack,
    disabled,
    emailSeqStatus,
    followUpStep,
    emailStatus,
  } = props;
  const steps = [
    {
      stepTitle:
        "+1 HOUR AFTER THE PROSPECT WAS MARKED AS A NO-SHOW BY THE USER",
      stepText: "Send the MISSED MEETING -- TEMPLATE.",
      stepContent: (
        <StepEmailContent
          content={emailSeqStatus?.["1"]}
          status={emailStatus}
        />
      ),
    },
    {
      stepTitle: "+2 DAYS AFTER PREVIOUS EMAIL",
      stepText:
        "If the LAST email was not opened, send the MISSED MEETING -- TEMPLATE.",
      stepContent: (
        <StepEmailContent
          content={emailSeqStatus?.["2"]}
          status={emailStatus}
        />
      ),
    },

    {
      stepTitle: "+5 DAYS AFTER PREVIOUS EMAIL",
      stepText:
        "If the LAST email was not opened, send the MISSED MEETING -- TEMPLATE.",
      stepContent: (
        <StepEmailContent
          content={emailSeqStatus?.["3"]}
          status={emailStatus}
        />
      ),
    },
    {
      stepTitle: "+7 DAYS AFTER PREVIOUS EMAIL",
      stepText:
        "If the prospect HAS BOOKED A MEETING or they have not REPLIED or BOOKED A MEETING then remove prospect from the journey.",
      stepContent: (
        <StepEmailContent
          content={emailSeqStatus?.["4"]}
          status={emailStatus}
        />
      ),
    },
  ];

  return (
    <Stack 
      spacing={3} 
      gap={3} 
      direction="column" 
      className="contentBorder glass-wrapper-50"
      sx={{
        backgroundColor: theme => alpha(theme.palette.primary.main, 0.1),
        border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
      }}
    >
      {/* <>
        <Stack direction="row" spacing={1}>
          <img src={StepOneIcon} />
          <Typography
            variant="h6"
            sx={{ color: "#050C46", fontSize: "16px", fontWeight: "700" }}>
            +1 Hour After Previous Email
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ padding: "0px 28px" }}>
          <IconButton sx={{ p: 0 }}>
            <img src={Check} height="20px" />
          </IconButton>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 500, color: "#050C46" }}>
            If the LAST email was not opened, send the MISSED MEETING --
            TEMPLATE (A)
          </Typography>
        </Stack>
      </>
      <Divider />
      <>
        <Stack direction="row" spacing={1}>
          <img src={StepOneIcon} />
          <Typography variant="h6" sx={{ color: "#050C46" }}>
            +2 Day After Previous Email
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ padding: "0px 28px" }}>
          <IconButton sx={{ p: 0 }}>
            <img src={Check} height="20px" />
          </IconButton>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 500, color: "#050C46" }}>
            If the LAST email was not opened, send the MISSED MEETING - TEMPLATE
            (A)
          </Typography>
        </Stack>
      </>
      <Divider />
      <>
        <Stack direction="row" spacing={1}>
          <img src={StepOneIcon} />
          <Typography variant="h6" sx={{ color: "#050C46" }}>
            +3 Day After Previous Email
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ padding: "0px 28px" }}>
          <IconButton sx={{ p: 0 }}>
            <img src={Check} height="20px" />
          </IconButton>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 500, color: "#050C46" }}>
            If the LAST email was not opened, send the MISSED MEETING - TEMPLATE
            (A)
          </Typography>
        </Stack>
      </>
      <Divider />
      <>
        <Stack direction="row" spacing={1}>
          <img src={StepOneIcon} />
          <Typography variant="h6" sx={{ color: "#050C46" }}>
            +5 Day After Previous Email
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ padding: "0px 28px" }}>
          <IconButton sx={{ p: 0 }}>
            <img src={Check} height="20px" />
          </IconButton>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 500, color: "#050C46" }}>
            If the LAST email was not opened, send the MISSED MEETING - TEMPLATE
            (B)
          </Typography>
        </Stack>
      </>
      <Divider />
      <>
        <Stack direction="row" spacing={1}>
          <img src={StepOneIcon} />
          <Typography variant="h6" sx={{ color: "#050C46" }}>
            +7 Day After Previous Email
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ padding: "0px 28px" }}>
          <IconButton sx={{ p: 0 }}>
            <img src={Check} height="20px" />
          </IconButton>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 500, color: "#050C46" }}>
            If the prospect still has not taken any ACTION (conversation, reply,
            meeting) other than open or click, then REMOVE the prospect from
            future emails.
          </Typography>
        </Stack>
      </> */}
      {steps.map((step, index) => (
        <>
          {" "}
          <StepItem
            key={index}
            stepNum={index + 1}
            stepTitle={step.stepTitle}
            stepText={step.stepText}
            stepContent={step.stepContent}
            completed={!!emailSeqStatus?.[`${index + 1}`]}
          />
          {index < steps.length - 1 && (
            <Divider sx={{ "&.MuiDivider-root": { my: 0 } }} />
          )}
        </>
      ))}
      <Stack direction="row" spacing={1}>
        <Button
          fullWidth
          size="small"
          className="BackButton glass-button-secondary-50"
          onClick={onBack}
          // disabled={disabled}
          variant="outlined"
        >
          Back
        </Button>

        <Button
          fullWidth
          className="currentButton glass-button-secondary-50"
          onClick={onNext}
          // disabled={disabled}
        >
          Next Stage
        </Button>
      </Stack>
    </Stack>
  );
};
